import { Environment } from './types';

const ENVIRONMENT: Environment = import.meta.env.VITE_ENVIRONMENT;

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

const GOOGLE_OATUH_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;

const ENABLE_ANALYTICS = import.meta.env.VITE_ENABLE_ANALYTICS === 'true';

const POSTHOG_KEY = ENABLE_ANALYTICS ? import.meta.env.VITE_POSTHOG_KEY : '';

const POSTHOG_HOST = ENABLE_ANALYTICS ? import.meta.env.VITE_POSTHOG_HOST : '';

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

const ENABLE_REACT_QUERY_DEV_TOOL = import.meta.env.VITE_ENABLE_REACT_QUERY_DEV_TOOL === 'true';

const MARKER_IO_PROJECT_ID = import.meta.env.VITE_MARKER_IO_PROJECT_ID;

const GLOBAL_ERROR_MESSAGE =
  'An error occurred while processing your request. Please try again later.';

const PROFILE_UNSAVED_MESSAGE =
  "We couldn't save the contact, but we'll try again shortly in the background.";

const PROFILE_PROBLEM_ERROR_MESSAGE =
  'There was an error while reporting the problem. Please try again later.';

const PROFILE_PROBLEM_SUCCESS_MESSAGE =
  'Your problem has been reported successfully. We will review it shortly.';

const TOOLTIP_DELAY_DURATION = 200;

export {
  ENVIRONMENT,
  API_BASE_URL,
  GOOGLE_OATUH_CLIENT_ID,
  ENABLE_ANALYTICS,
  POSTHOG_KEY,
  POSTHOG_HOST,
  SENTRY_DSN,
  ENABLE_REACT_QUERY_DEV_TOOL,
  GLOBAL_ERROR_MESSAGE,
  PROFILE_UNSAVED_MESSAGE,
  MARKER_IO_PROJECT_ID,
  TOOLTIP_DELAY_DURATION,
  PROFILE_PROBLEM_ERROR_MESSAGE,
  PROFILE_PROBLEM_SUCCESS_MESSAGE,
};
